export default {
  ACTIVE: 'ACTIVE',
  ACTIVE_PLUS: 'ACTIVE_PLUS',
  FOUNDER: 'FOUNDER'
}
